var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _vm.updateGuide ? _c("div", { staticClass: "updateGuide" }) : _vm._e(),
      _c(
        "div",
        { staticClass: "wl-content-container" },
        [
          _c("div", { staticClass: "wl-search-bar" }, [
            _c(
              "div",
              { staticClass: "wl-left" },
              [
                _c(
                  "el-input",
                  {
                    staticClass: "input-with-select",
                    attrs: {
                      placeholder:
                        _vm.$t("USER_WORKING_EMAIL") +
                        "," +
                        _vm.$t("COMMON_USER_NAME"),
                      clearable: "",
                      maxlength: "100",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchUser.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchContent,
                      callback: function ($$v) {
                        _vm.searchContent = $$v
                      },
                      expression: "searchContent",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-input__icon el-icon-search",
                      staticStyle: { cursor: "pointer" },
                      attrs: { slot: "suffix" },
                      on: { click: _vm.searchUser },
                      slot: "suffix",
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "wl-right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { icon: "el-icon-plus" },
                    on: { click: _vm.addClientUser },
                  },
                  [_vm._v(_vm._s(_vm.$t("ADD_CLIENT_USER")) + "\n        ")]
                ),
                _c(
                  "el-popover",
                  {
                    staticStyle: { margin: "0 10px" },
                    attrs: {
                      width: _vm.$i18n.locale === "zh" ? 267 : 403,
                      trigger: "manual",
                      placement: "top-start",
                      "popper-class": "clientUser-popver-content",
                    },
                    model: {
                      value: _vm.ifUnsendPwdUserExist,
                      callback: function ($$v) {
                        _vm.ifUnsendPwdUserExist = $$v
                      },
                      expression: "ifUnsendPwdUserExist",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "wl-green",
                        attrs: { slot: "reference", icon: "el-icon-message" },
                        on: { click: _vm.sendEmailOpen },
                        slot: "reference",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("PAGE_CLIENTUSER_PAD_EMAIL")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c("div", {}, [
                      _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                        _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: { color: "#fd349c" },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("please_sent_initial_password")) +
                            "\n            "
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "flex-end",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function ($event) {
                                  _vm.ifUnsendPwdUserExist =
                                    !_vm.ifUnsendPwdUserExist
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("i_know")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "popver-arrow" }),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { icon: "el-icon-document" },
                    on: { click: _vm.showWhiteList },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("SET_WHITE_LIST")) +
                        "\n        "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { icon: "el-icon-document" },
                    on: { click: _vm.showIpWhiteList },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("SET_IP_WHITE_LIST")) +
                        "\n        "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green svg-btn",
                    staticStyle: { "margin-left": "10px" },
                    attrs: { disabled: _vm.multiSelect.show },
                    on: { click: _vm.assignSameRole },
                  },
                  [
                    _c("img", {
                      staticClass: "btn-icon",
                      attrs: {
                        src: require("@/assets/img/icon-batchsetting.svg"),
                        width: "100%",
                      },
                    }),
                    _vm._v(_vm._s(_vm.$t("patch_set_role")) + "\n        "),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green svg-btn",
                    attrs: { disabled: _vm.multiSelect.show },
                    on: { click: _vm.patchDelete },
                  },
                  [
                    _c("img", {
                      staticClass: "btn-icon",
                      attrs: {
                        src: require("@/assets/img/icon-batchdeletion.svg"),
                        width: "100%",
                      },
                    }),
                    _vm._v(_vm._s(_vm.$t("patch_delete_user")) + "\n        "),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { icon: "el-icon-download" },
                    on: { click: _vm.download },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("COMMON_DOWNLOAD_TEMP")) +
                        "\n        "
                    ),
                  ]
                ),
                _c(
                  "el-upload",
                  {
                    staticClass: "template-uploader",
                    attrs: {
                      action: "url",
                      "http-request": _vm.uploadFiles,
                      "show-file-list": false,
                      "on-success": _vm.handleAvatarSuccess,
                      "before-upload": _vm.beforeAvatarUpload,
                    },
                  },
                  [
                    _c("el-button", { staticClass: "wl-green svg-btn" }, [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-import.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("batchImport")) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    staticStyle: { "margin-left": "10px" },
                    attrs: { icon: "el-icon-download" },
                    on: { click: _vm.downloadClientUser },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("cilentExportUserList")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "font-size": "12PX", color: "#fd349c" } },
            [
              _c("i", { staticClass: "el-icon-warning" }),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("CLIENT_USERS_TIPS")) + "\n    "
              ),
            ]
          ),
          _c(
            "div",
            {
              class: [
                "table-container-wrapper",
                _vm.multiSelect.show ? "show-table-bottom-operate" : "",
                { "guide-table": _vm.updateGuide },
              ],
            },
            [
              _vm.updateGuide
                ? _c(
                    "div",
                    {
                      staticClass: "updateGuideTitle",
                      style: {
                        height: `${_vm.updateGuideTitleHeight}px`,
                        right: "100px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "updateGuideTip",
                          style: {
                            top: `${_vm.updateGuideTitleHeight + 10}px`,
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("CLIENT_NOTICE")),
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticClass: "guide-btn",
                              on: { click: _vm.gotItClick },
                            },
                            [_vm._v(_vm._s(_vm.$t("gotIt")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "table",
                  attrs: {
                    height: "100%",
                    data: _vm.data,
                    "row-class-name": _vm.userSourceRowClass,
                    "cell-class-name": _vm.noRoleCell,
                    border: "",
                    stripe: "",
                    "header-cell-class-name": _vm.updateGuideClass,
                  },
                  on: {
                    "selection-change": (e) => {
                      _vm.multiSelect.choosed = e
                    },
                  },
                },
                [
                  _vm.multiSelect.show
                    ? _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { align: "center", type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userAccount",
                      width: "150",
                      label: _vm.$t("USER_WORKING_EMAIL"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "phone",
                      width: "120",
                      label: _vm.$t("USER_WORKING_PHONE"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: _vm.$t("TABLE_HEADER_title2"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userName",
                      label: _vm.$t("COMMON_USER_NAME"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createDate",
                      width: "110",
                      label: _vm.$t("create_date"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(
                                    scope.row.createDateString
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "identityType",
                      "min-width": "230",
                      label: _vm.$t("TABLE_HEADER_CLIENT_IDENTITY"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "TABLE_HEADER_CLIENT_IDENTITY"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeIdentityType(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.identityType,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "identityType", $$v)
                                  },
                                  expression: "scope.row.identityType",
                                },
                              },
                              _vm._l(_vm.identityTypeOpt, function (item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.value,
                                    value: item.code,
                                  },
                                })
                              }),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ifContact",
                      align: "center",
                      width: "150",
                      label: _vm.$t("TABLE_HEADER_ifContact"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              staticClass: "switch-width-cls",
                              attrs: {
                                "active-color": "#3879eb",
                                "inactive-color": "#a9acaf",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeIfContact(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.ifContact,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "ifContact", $$v)
                                },
                                expression: "scope.row.ifContact",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      width: "170",
                      label: _vm.$t("Activated"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.deactivateDescription
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: scope.row.deactivateDescription,
                                    },
                                  },
                                  [
                                    _c("el-switch", {
                                      staticClass: "switch-width-cls",
                                      attrs: {
                                        "active-value": "1",
                                        "inactive-value": "0",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeStatus(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.status,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "status", $$v)
                                        },
                                        expression: "scope.row.status",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("el-switch", {
                                  staticClass: "switch-width-cls",
                                  attrs: {
                                    "active-value": "1",
                                    "inactive-value": "0",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeStatus(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "status", $$v)
                                    },
                                    expression: "scope.row.status",
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deactivateSetting",
                      width: "140",
                      label: _vm.$t("Deactivate_Setting"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "th" },
                              [
                                _c("div", { staticClass: "th-label" }, [
                                  _vm._v(_vm._s(_vm.$t("Deactivate_Setting"))),
                                ]),
                                _c(
                                  "el-dropdown",
                                  {
                                    on: { command: _vm.onDeactivateBatchEdit },
                                  },
                                  [
                                    _c("div", { staticClass: "th-edit" }, [
                                      _c("i", {
                                        staticClass: "el-icon-edit-outline",
                                      }),
                                    ]),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _vm._l(
                                          _vm.deactivateSettingOptions,
                                          function (v, k) {
                                            return [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  key: k,
                                                  attrs: { command: v.code },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `deactivate_setting._${v.code}`
                                                      )
                                                    ) + "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: scope.row.status === "0",
                                  placeholder: _vm.$t("Deactivate_Setting"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onDeactivateEdit(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.deactivateSetting,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "deactivateSetting",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.deactivateSetting",
                                },
                              },
                              _vm._l(
                                _vm.deactivateSettingOptions,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: _vm.$t(
                                        `deactivate_setting._${item.code}`
                                      ),
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastActiveTime",
                      width: "100",
                      label: _vm.$t("Last_Active_Time"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100", label: _vm.$t("Date_Type") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              { staticStyle: { "word-break": "break-word" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      `activeTimeType_${scope.row.activeTimeType}`
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: { width: "180", fixed: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("AccessLevelSelect", {
                                attrs: {
                                  initData: scope.row.accessType,
                                  tailoredShow: "",
                                },
                                on: {
                                  change: (val) =>
                                    _vm.handleAccessLevelChange(scope.row, val),
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#fd349c",
                                "margin-right": "5px",
                                "vertical-align": "center",
                              },
                            },
                            [_vm._v("*")]
                          ),
                          _vm._v(
                            _vm._s(_vm.$t("CLIENT_TABLE_HEADER_Access_Level")) +
                              "\n                  "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" },
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "CLIENT_TABLE_HEADER_Access_Level_Tip"
                                    )
                                  ),
                                },
                                slot: "content",
                              }),
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  color: "#fd349c",
                                  "margin-right": "5px",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        width: "190",
                        fixed: "right",
                        label: _vm.$t("CLIENT_TABLE_HEADER_CLIENT_ENTITIES"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.accessType
                                ? _c("el-select", {
                                    key: scope.$index + "null",
                                    staticStyle: { width: "100%" },
                                    attrs: { value: "" },
                                  })
                                : scope.row.accessType === "ALL"
                                ? _c("el-select", {
                                    key: scope.$index + "All",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      value: _vm.$t("All_ENTITIES"),
                                    },
                                  })
                                : scope.row.accessType === "SPECIFIC" &&
                                  scope.row.refresh
                                ? _c("select-tree", {
                                    key: scope.row.id,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "mini",
                                      data: _vm.orgData,
                                      filterable: true,
                                      "check-strictly": true,
                                      defaultCheckedKeys:
                                        scope.row.clientEntityIds,
                                      defaultExpandAll: true,
                                      defaultProps: _vm.defaultProps,
                                      placeholder: _vm.$t("SELECT_TYPE"),
                                    },
                                    on: {
                                      "visible-change": (list) =>
                                        _vm.handleVisibleChange(
                                          scope.row,
                                          list
                                        ),
                                    },
                                  })
                                : _c(
                                    "el-select",
                                    {
                                      staticClass: "mb_20",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "collapse-tags": "",
                                        multiple: "",
                                        placeholder: _vm.$t("SELECT_ROLE_TYPE"),
                                      },
                                      on: {
                                        "visible-change": (val) =>
                                          _vm.handleRoleChange(scope.row, val),
                                      },
                                      model: {
                                        value: scope.row.roleList,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "roleList", $$v)
                                        },
                                        expression: "scope.row.roleList",
                                      },
                                    },
                                    _vm._l(_vm.roleList, function (item) {
                                      return _c("el-option", {
                                        key: item.roleId,
                                        attrs: {
                                          label: item.roleName,
                                          value: item.roleId,
                                          disabled: _vm.loading,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#fd349c",
                              "margin-right": "5px",
                              "vertical-align": "center",
                            },
                          },
                          [_vm._v("*")]
                        ),
                        _vm._v(
                          _vm._s(
                            _vm.$t("CLIENT_TABLE_HEADER_CLIENT_ENTITIES")
                          ) + "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action",
                      fixed: "right",
                      width: "100",
                      align: "center",
                      label: _vm.$t("TABLE_HEADER_Action"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("i", {
                              staticClass: "el-icon-edit-outline wl-icon-edit",
                              on: {
                                click: function ($event) {
                                  return _vm.onEditClientUser(scope.row)
                                },
                              },
                            }),
                            _c("i", {
                              staticClass: "el-icon-delete wl-icon-delete",
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDeleteClientUser(scope.row)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.multiSelect.show,
                  expression: "multiSelect.show",
                },
              ],
              staticClass: "wl-btn-container",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  on: { click: _vm.cancelPatchMethod },
                },
                [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { disabled: _vm.multiSelect.choosed.length === 0 },
                  on: { click: _vm.commitPatchMethod },
                },
                [
                  _vm._v(
                    _vm._s(
                      {
                        assign_role: _vm.$t("patch_set_role"),
                        patch_delete: _vm.$t("patch_delete_user"),
                      }[_vm.multiSelect.mode]
                    ) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              "current-page": _vm.pagination.pageNum,
              "page-size": _vm.pagination.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
              total: _vm.pagination.total,
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.onCurrentPageChange,
            },
          }),
        ],
        1
      ),
      _c("patchRoleDialog", {
        attrs: {
          visible: _vm.patchRoleVisible,
          roleList: _vm.roleList,
          allNodes: _vm.allNodes,
          data: _vm.orgData,
        },
        on: {
          submit: _vm.batchSetRole,
          close: function ($event) {
            _vm.patchRoleVisible = false
          },
        },
      }),
      _vm.addVisible
        ? _c("clientUser-add", {
            attrs: {
              saveLoading: _vm.btnLoading,
              roleList: _vm.roleList,
              identityTypeOpt: _vm.identityTypeOpt,
              initData: _vm.initData,
              emailList: _vm.emailList,
              onCancel: _vm.toggleAddVisible,
              onAdd: _vm.saveClientUser,
            },
          })
        : _vm._e(),
      _vm.addVisibleEmail
        ? _c("clientUser-email", {
            attrs: {
              roleList: _vm.roleList,
              saveLoading: _vm.emailBtnLoading,
              onCancel: _vm.toogleEmailVisible,
              onAdd: _vm.sendEmail,
            },
          })
        : _vm._e(),
      _vm.whiteListVisible
        ? _c("whiteList", { attrs: { whiteListVisible: _vm.whiteListVisible } })
        : _vm._e(),
      _vm.ipWhiteListVisible
        ? _c("ip-white-list", {
            attrs: { ipWhiteListVisible: _vm.ipWhiteListVisible },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }